module.exports = __webpack_public_path__ + "img/check.a05f6676.svg";